import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { RootState } from "store";
import { LoginVisibleType, ReportableType } from "./uiSlice";

const getState = (state: RootState) => state;

export const getUiChannel = createSelector(getState, (state) => state.ui);

export const getIsLoginVisible = createSelector(
  getUiChannel,
  ({ loginVisible }) => {
    return loginVisible || false;
  }
);

export function useIsLoginVisible(): LoginVisibleType {
  return useSelector(getIsLoginVisible);
}

export const getTheme = createSelector(getUiChannel, ({ theme }) => {
  return theme;
});

export default function useCurrentTheme(): "light" | "dark" | "system" {
  return useSelector(getTheme);
}


export const getReport = () =>
  createSelector(getUiChannel, ({ report }): ReportableType | null => {
    return report;
  });

export function useReport(): ReportableType | null {
  return useSelector(getReport());
}